import React from 'react';
import Tabs, { TabsProps } from '@mui/material/Tabs';

interface AppTabsProps extends TabsProps {
  size?: 'default' | 'compact';
}

const AppTabs: React.FC<AppTabsProps> = ({ size = 'default', sx, ...props }) => (
  <Tabs
    TabIndicatorProps={{ style: { backgroundColor: '#2C91AD' } }}
    sx={{
      ...(size === 'compact' && { minHeight: 36 }),
      '& .MuiTab-root': {
        fontFamily: 'Inter',
        fontSize: size === 'compact' ? '12px' : '13px',
        textTransform: 'none',
        fontWeight: 500,
        color: '#8A98A8',
        ...(size === 'compact' && { minHeight: 36, py: 0.5 }),
      },
      '& .Mui-selected': { color: '#2C91AD !important', fontWeight: 600 },
      ...sx,
    }}
    {...props}
  />
);

export default AppTabs;